import {GeneralAction, UserPayload} from '../../../@types/actions';
import {PLAYER_INITIALIZE} from '../../../constants/PlayerConstants';

export const GetInitAction = (userId: string): GeneralAction<UserPayload> => ({
    type: PLAYER_INITIALIZE,
    payload: {userId}
});
